<script>
export default {
    methods: {
        checkLoginStatus() {
            // this.$axios.get(route('admin')).then(response => {
            //     window.location = route('admin');
            // }).catch (error => {
            //     // Do nothing - just means they aren't logged in or some other forbidden/etc. status
            // });
        },
    },

    mounted() {
        // Check every minute for 5 minutes if the person's logged in to auto-redirect
        let longTermCounter = 0;
        let longTermLoggedInChecker = setInterval(() => {
            this.checkLoginStatus();
            if (++longTermCounter >= 5) {
                clearInterval(longTermLoggedInChecker);
            }
        }, 60000);

        // Check every 0.5 seconds for 2.5 seconds if they're logged in to auto-redirect
        let counter = 0;
        let loggedInChecker = setInterval(() => {
            this.checkLoginStatus();
            if (++counter >= 5) {
                clearInterval(loggedInChecker);
            }
        }, 500);

        // Do a quick check 100ms after mounting if they're logged in to auto-redirect
        setTimeout(this.checkLoginStatus, 100);
    },
};
</script>
